import type {
	GoalSummaryLine,
	GoalSummaryLineInput,
} from "web_myplann/Goals/Types/GoalSummaryLine";
import { GOAL_CATEGORY_CONFIG } from "web_myplann/Goals/Types/GoalTypes";

export const mapToGoalSummaryLine = (
	goal: GoalSummaryLineInput,
): GoalSummaryLine | null => {
	if (goal.completed || goal.price === null || goal.price <= 0) return null;
	if (goal.ownFunds <= 0 && goal.loanAmount <= 0) return null;

	const loanKind = GOAL_CATEGORY_CONFIG[goal.category].loan;

	return {
		price: goal.price,
		mustHave: Math.max(0, goal.price - goal.loanAmount),
		ownFunds: goal.ownFunds,
		loanAmount: goal.loanAmount,
		loanKind,
		withLoanBreakdown: loanKind !== null || goal.loanAmount > 0,
	};
};
